import React from 'react';

import { CountryItemPanel } from '../components/CountryItemPanel/CountryItemPanel';

const CountryItemWithCode = (props) => {
    const country = props.country;
    const prefix = props.isRequest ? country.phonePrefix : country.prefix;

    const click = () => {
        props.onCountryItemClick(country.code, prefix, country.name);
    };

    return (
        <CountryItemPanel
            flagIconName={country.code}
            isSelectedCountry={props.iso2 === country.code}
            onClick={click}
            countryName={country.name}
            countryPrefix={prefix}
            query={props.query}
        />
    );
};

export default CountryItemWithCode;
